<app-menu-bar></app-menu-bar>
<div id="project">
    <div class="title-area">
        <span class="title">{{ project?.title }}</span>
        <span class="description">{{ project?.description }}</span>
    </div>
    <img [src]="project?.imageUrl" alt="" class="project-image img-fluid">
    <div class="details-area">
        <div class="problem-solution">
            <div class="d-flex gap-3 flex-column">
                <span class="title">{{ 'project_problem' | translate }}</span>
                <span class="description">{{ project?.problemStatement }}</span>
            </div>
            <div class="d-flex gap-3 flex-column">
                <span class="title">{{ 'project_solution' | translate }}</span>
                <span class="description">{{ project?.solution }}</span>
            </div>

        </div>
        <!-- Location only, and only when set. Industry and Year stay out until
             that data is reliable — the markup is kept below for that day. -->
        @if (project?.location) {
            <div class="other-details">
                <div class="detail-item">
                    <span class="label">{{ 'project_location' | translate }}</span>
                    <span class="value">{{ project?.location }}</span>
                </div>
            </div>
        }
        <!-- <div class="detail-item">
            <span class="label">{{ 'project_industry' | translate }}</span>
            <span class="value">{{project?.industry}}</span>
        </div>
        <div class="detail-item">
            <span class="label">{{ 'project_year' | translate }}</span>
            <span class="value">{{project?.year}}</span>
        </div> -->
    </div>
    <div class="carousel-area">
        <span class="title">{{ 'project_carousel_title' | translate }}</span>
        @if (carouselItems.length) {
            <app-image-carousel [carouselItems]="carouselItems"></app-image-carousel>
        }
    </div>
</div>
<app-footer></app-footer>